import { FC } from 'react'

import { Accordion } from '@syconium/little-miss-figgy'

import {
  AccordionViewFragmentFragment,
  RawHtmlSectionFragmentFragment,
  RichTextSectionFragmentFragment,
} from '../../../../__generated__/graphql/catalog/graphql'
import { ContentfulRawHtml } from '../../../../app/_components/pages/contentful/components/ContentfulRawHtml'
import { ContentfulRichText } from '../../../../app/_components/pages/contentful/components/ContentfulRichText'
import { ContentfulStyledText } from '../../../../app/_components/pages/contentful/components/ContentfulStyledText'
import * as ContentfulAccordion from '../../../../app/_components/pages/contentful/sections/ContentfulPageAccordionViewSection.client'
import { AccordionTitle } from '../../../../components/pages/products/ProductPage/DetailsSection/ProductDetailsAccordionSection/ProductDetailsAccordionSection.styles'

import {
  PageSectionAccordionBody,
  PageSectionAccordionHeader,
  PageSectionAccordionWrapper,
} from './styles'

const renderAccordionContent = (
  props: RichTextSectionFragmentFragment | RawHtmlSectionFragmentFragment | null,
  index: number
): JSX.Element | null => {
  const key: string = `${props?.id}-${index}`
  switch (props?.__typename) {
    case 'RichTextSection':
      return <ContentfulRichText key={key} {...props} />
    case 'RawHtmlSection':
      return <ContentfulRawHtml key={key} {...props} />
    default:
      return null
  }
}

export const AccordionView: FC<AccordionViewFragmentFragment> = ({
  heading,
  variant,
  maxWidth,
  sections,
}) => {
  return (
    <PageSectionAccordionWrapper maxWidth={maxWidth ?? undefined}>
      {heading && (
        <ContentfulAccordion.Heading>
          <ContentfulStyledText {...heading} />
        </ContentfulAccordion.Heading>
      )}
      <Accordion
        variant={variant}
        icon='plus'
        aria-label='Detail Section'
        showBorder
        multiOpen
        withAnimation
      >
        {sections.map((section, index) => (
          <Accordion.Section id={index}>
            <PageSectionAccordionHeader $flush={!['subtle', 'subtleWhileActive'].includes(variant)}>
              <AccordionTitle textTransform='uppercase' asTag='p'>
                {section.title}
              </AccordionTitle>
            </PageSectionAccordionHeader>
            <PageSectionAccordionBody>
              <div>{renderAccordionContent(section.content, index)}</div>
            </PageSectionAccordionBody>
          </Accordion.Section>
        ))}
      </Accordion>
    </PageSectionAccordionWrapper>
  )
}
